<template lang="pug">
  .profile-page__content
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title При въезде на базу отдыха иметь

      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Пункты
              .form-elem__body
                input.input.input_full(
                  maxlength="50"
                  value="Медицинские справки"
                )
          .form__elem.form__elem--align-right
            button.button.button_paint-main--light
              //.button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить пункт
    section.form__elem.form__elem--align-right.form__elem_full
      button.button.button_paint-main.button_long
        .button__text Сохранить

</template>

<script>
export default {
  name: "OperatorCampAbout",
  data() {
    return {};
  }
};
</script>
